import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useUserPermissions } from '../hooks/useUserPermissions';

interface DeliverablesAdminRouteProps {
  children?: React.ReactNode;
}

/**
 * Route guard for Deliverables admin pages
 * Requires the user to have 'deliverables.all' permission
 * Redirects to access denied if permission is missing
 */
export const DeliverablesAdminRoute: React.FC<DeliverablesAdminRouteProps> = ({ children }) => {
  const { hasPermission, isLoading } = useUserPermissions();

  // Show loading while checking permissions
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Check for Deliverables admin permission
  if (!hasPermission('deliverables.all')) {
    return <Navigate to="/access-denied" replace />;
  }

  return <>{children || <Outlet />}</>;
};
